import { t } from "@/i18n";

export type MemberBoardData = {
    name: string;
    email: string;
    access: "owner" | "edit" | "view" | "view_copy";
    accountId: number;
    memberId: number;
};

export type BoardShareResponse = {
    accessByTeam: "owner" | "edit" | "view";
    accessByLink: "owner" | "edit" | "view";
    teamId: number;
    access: "owner" | "edit" | "view";
    teamName: string;
    inviteLink: string;
    allowControlByLink: "allow" | "deny";
    members: MemberBoardData[];
};

export interface MemberAccessInterface {
    members: string[];
    access: AccessEnum;
}
export enum AccessEnum {
    owner = "owner",
    view = "view",
    edit = "edit",
    denied = "denied",
    viewCopy = "view_copy",
}

export enum AccessDeleteEnum {
    delete = "delete",
    view = "view",
    edit = "edit",
}

export interface Option {
    value: number | string;
    label: string;
    text?: string;
}

export enum BoardAccessEnum {
    edit = "edit",
    view = "view",
    denied = "denied",
    viewCopy = "view_copy",
}

export const getAccessEnumTextExt = () => ({
    [AccessEnum.view]: t("share.accessView"),
    [AccessEnum.viewCopy]: t("share.accessViewCopy"),
    [AccessEnum.edit]: t("share.accessEdit"),
    [AccessEnum.owner]: t("share.accessOwner"),
    [AccessEnum.denied]: t("share.accessDenied"),
});

export const getAccessDeleteEnumToText = () => ({
    [AccessDeleteEnum.view]: t("share.accessView"),
    [AccessDeleteEnum.edit]: t("share.accessEdit"),
    [AccessDeleteEnum.delete]: t("share.accessDelete"),
});

export const getBoardAccessEnumToText = () => ({
    [BoardAccessEnum.view]: t("share.accessView"),
    [BoardAccessEnum.viewCopy]: t("share.accessViewCopy"),
    [BoardAccessEnum.edit]: t("share.accessEdit"),
    [BoardAccessEnum.denied]: t("share.accessDenied"),
});

export type AccessOption = AccessDeleteEnum | BoardAccessEnum;

export interface TeamMemberType {
    teamId: number;
    filter: string;
    rawFilter: string;
    onSelect: (member: Member) => void;
}

export type Member = {
    accountId: string;
    email: string;
    name: string;
    role: string;
};

export interface MemberAccessInterface {
    members: string[];
    access: AccessEnum;
}
